export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9247.9a44974d.jpg";